<div class="h4">Aanvullende Compleetdekking</div>
<p>
    Uw spullen zijn verzekerd met de Compleetdekking als u, iemand uit uw gezin of uw huisdier iets omstoot of laat
    vallen. Ook buitenshuis in Nederland is schade aan film-, fotoapparatuur, sieraden muziekinstrumenten, duik-,
    paarden, golf- en hengelsportspullen verzekerd. De Compleetdekking geldt voor de afgesloten dekkingen (Inboedel,
    Opstal en Eigenaars-/huurdersbelang).
</p>
<p>
    <strong>Maar let op:</strong>
    schade aan mobiele elektronica door vallen en stoten is niet verzekerd met Compleet. Daarvoor heeft u onze aparte
    Mobiele Elektronica dekking nodig.
</p>
